module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/libao-e319150bd5e009ac99b5f7fd57d0a455.png";